import { Box, Text } from "flicket-ui";
import React from "react";
import { formatEventDate } from "~lib/helpers/formatDate";
import { FormatDateOptions } from "@flicket/utils";

interface DateDisplayProps {
  day: string;
  month: string;
}

/**
 * Component for displaying a formatted date with day and month
 *
 * @param props - Component props
 * @param props.day - Day number to display
 * @param props.month - Month name to display
 */
export const DateDisplay: React.FC<DateDisplayProps> = ({ day, month }) => {
  return (
    <Box>
      <Text variant="header.M">{day}</Text>
      <Text variant="regular" textTransform="uppercase">
        {month}
      </Text>
    </Box>
  );
};

/**
 * Helper function to format date for the DateDisplay component
 *
 * @param startDate - Event start date
 * @param options - Date formatting options
 * @returns Object containing formatted day and month
 */
export const formatDateForDisplay = (
  startDate: string | null | undefined,
  options?: FormatDateOptions
): { day: string; month: string } => {
  if (!startDate) {
    return { day: "", month: "" };
  }

  const day = formatEventDate(startDate, "custom", {
    day: "numeric",
    ...options,
  });

  const month = formatEventDate(startDate, "custom", {
    month: "short",
    ...options,
  }).toUpperCase();

  return { day, month };
};
